var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTagSpecial = function SvgTagSpecial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 79 36",
    fill: "none",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m36.886 36-9.349-5.505-9 3.025-3.517-6.534-13.518 1.139 7.847-6.6L0 15.64l10.514-2.666L8.348 5.13l10.19 3.622L30.183 0l4.864 6.095L48.566 0l6.508 7.237 16.523-2.106-1.575 9.725 6.175 2.098-6.175 3.279L79 24.393l-11.117 2.593 2.212 4.652-10.514-3.07-3.005 7.051-9.512-3.981L36.886 36Z",
    fill: "currentColor"
  })));
};

export default SvgTagSpecial;